import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    getSaleItemsAsync,
    getSaleItemsCountAsync,
    selectSaleFilterOptions
} from "../../../../store/reducers/warehouse/saleReducer";
import {selectActiveOrganization} from "../../../../store/reducers/auth/authReducer";
import EventBus from "../../../../eventbus/EventBus";
import {WAREHOUSE_OPERATION_SALE_DELETE_SUCCESS} from "../../../../eventbus/saleEvents";
import SaleDatatable from "../../../../components/warehouse/operation/sale/SaleDatatable";

const Sales = () => {
    const activeOrganization = useSelector(selectActiveOrganization);
    const filters = useSelector(selectSaleFilterOptions);
    const dispatch = useDispatch();

    useEffect(() => {
        loadSales();
    }, [activeOrganization, filters])

    useEffect(() => {
        const onSaleDeletedHandler = EventBus.on(WAREHOUSE_OPERATION_SALE_DELETE_SUCCESS, () => {
            loadSales();
        });

        return () => {
            EventBus.remove(WAREHOUSE_OPERATION_SALE_DELETE_SUCCESS, onSaleDeletedHandler)
        };
    }, [])

    const loadSales = () => {
        dispatch(getSaleItemsAsync({...filters}));
        dispatch(getSaleItemsCountAsync({...filters}));
    }

    return (
        <SaleDatatable />
    );
};

export default Sales;
